export default __webpack_public_path__ + "static/east-main-video4-ab92362acc3ed4e389e4a08636c7d8a6.jpg";